import { FC } from 'react';
import './Style.css';

interface ILoadingProps {
	text?: string;
	className?: string;
}

const Loading: FC<ILoadingProps> = ({ text = 'Loading', className = 'secondary' }) => {
	return (
		<div className="loader-container">
			<div className={`loader ${className}`}></div>
			<div className={`text ${className}`}>{text}</div>
		</div>
	);
};

export default Loading;
